export const gtmEvent = ({gtmID, gtmPayload = {}}) => {
  const newGtmPayload = gtmPayload
  if (gtmPayload.CMSGroupGTM) {
    newGtmPayload.CMSGroupGTM = {
      ...gtmPayload.CMSGroupGTM,
      eventID: gtmPayload.CMSGroupGTM.id,
      pageCategory: gtmPayload.CMSGroupGTM.category,
      pageAction: gtmPayload.CMSGroupGTM.action,
      customValue: gtmPayload.CMSGroupGTM.customValue,
      version: gtmPayload.CMSGroupGTM.version,
    }
  }
  return {
    type: gtmID,
    ...newGtmPayload,
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/gtm.js